module.exports = __webpack_public_path__ + "img/Malta.8b999d0d.gif";